<template>

    <Head>
        <title> BLOG </title>
        <meta name="robots" content="noindex">
    </Head>
    <SuggestedBlogs></SuggestedBlogs>
</template>

<script>
import SuggestedBlogs from "../../components/Shared/SuggestedBlogs.vue"
export default {
    data() {
        return {
        };
    },
    components: {
        SuggestedBlogs
    },


};

</script>